(() => {
  const revealSelectors = [
    '.cw-intro__grid','.cw-section-head','.cw-explore__grid','.cw-feature__media','.cw-feature__copy',
    '.cw-collection-card','.cw-standard__top','.cw-standard__grid','.cw-project',
    '.cw-trade__copy','.cw-trade__media','.cw-process-grid','.cw-cta .cw-shell'
  ];
  const initReveal = (root=document) => {
    const items = [...root.querySelectorAll(revealSelectors.join(','))].filter(el => !el.dataset.cwRevealReady);
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => { el.classList.add('cw-reveal','visible'); el.dataset.cwRevealReady='true'; });
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: .12 });
    items.forEach(el => { el.classList.add('cw-reveal'); el.dataset.cwRevealReady='true'; observer.observe(el); });
  };
  const initHeader = (root=document) => {
    root.querySelectorAll('[data-cw-header]').forEach(header => {
      if (header.dataset.cwHeaderReady) return;
      header.dataset.cwHeaderReady='true';
      const update = () => header.classList.toggle('scrolled', window.scrollY > 10);
      update();
      window.addEventListener('scroll', update, { passive:true });
    });
  };
  const closeMenu = () => {
    document.querySelectorAll('[data-cw-drawer]').forEach(x => x.classList.remove('open'));
    document.querySelectorAll('[data-cw-backdrop]').forEach(x => x.classList.remove('open'));
    document.body.style.overflow='';
  };
  document.addEventListener('click', e => {
    const sw=e.target.closest('[data-cw-swatch]');
    if(sw){
      const root=sw.closest('[data-cw-feature]');
      root.querySelectorAll('[data-cw-swatch]').forEach(x=>x.classList.remove('active'));
      sw.classList.add('active');
      root.querySelector('[data-cw-title]').textContent=sw.dataset.title;
      root.querySelector('[data-cw-type]').textContent=sw.dataset.type;
      root.querySelector('[data-cw-desc]').textContent=sw.dataset.desc;
    }
    if(e.target.closest('[data-cw-open-menu]')){
      document.querySelector('[data-cw-drawer]')?.classList.add('open');
      document.querySelector('[data-cw-backdrop]')?.classList.add('open');
      document.body.style.overflow='hidden';
    }
    if(e.target.closest('[data-cw-close-menu]') || e.target.closest('[data-cw-backdrop]') || e.target.closest('[data-cw-drawer] a')) closeMenu();
  });
  document.addEventListener('keydown', e => { if(e.key==='Escape') closeMenu(); });
  const init = (root=document) => { initReveal(root); initHeader(root); };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();